<nav class="sidebar-nav h-100 d-flex flex-column">
    <ul id="sidebarnav" class="flex-grow-1">
        <!-- User Profile-->
        <!-- <li class="border-bottom border-secondary">
            <div class="user-profile d-flex no-block">
                <div class="user-pic">
                    <img src="assets/images/users/1.jpg" alt="users" class="rounded-circle" width="36" />
                </div>
                <div class="user-content hide-menu m-l-10" ngbDropdown placement="bottom-left">
                    <a ngbDropdownToggle href="javascript:void(0)" id="Userdd">
                        <h5 class="m-b-0 user-name font-medium">
                            {{currentUserInfo?.userNm}}
                            <i class="fa fa-angle-down ml-2"></i>
                        </h5>
                        <span class="op-5 user-email">{{currentUserInfo?.userId}}</span>
                    </a>
                    <div class="dropdown-menu-right" aria-labelledby="Userdd" ngbDropdownMenu>
                        <button class="dropdown-item disabled">
                            <i class="fas fa-user-tag fa-fw mr-2"></i> {{currentUserInfo?.userGroupNm}}
                        </button>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="javascript:void(0)">
                            <i class="far fa-id-card fa-fw mr-2"></i> 프로필
                        </a>
                        <a class="dropdown-item" href="javascript:void(0)">
                            <i class="fas fa-sliders-h fa-fw mr-2"></i> 설정
                        </a>
                        <button class="dropdown-item disabled">
                            <i class="fas fa-info-circle fa-fw mr-2"></i> {{ipAccessDevice}}
                        </button>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="javascript:void(0)" (click)="clickLogOut()">
                            <i class="fa fa-power-off fa-fw mr-2"></i> Logout
                        </a>
                    </div>
                </div>
            </div>
        </li> -->
        <!-- First level menu -->
        <ng-container *ngFor="let sidebarnavItem of sidebarnavItems | filterParentMenuId:pMenuId | filterLimitLevel:userGroupId">
            <li class="sidebar-item"
                [class.active]="showMenu === sidebarnavItem.title"
                [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'">
                <div class="nav-small-cap" *ngIf="sidebarnavItem.extralink === true">{{sidebarnavItem.title}}</div>
                <a class="sidebar-link waves-effect waves-dark" [routerLink]="sidebarnavItem.class === '' ? [sidebarnavItem.path] : null"
                    [ngClass]="[sidebarnavItem.class]" *ngIf="!sidebarnavItem.extralink;" (click)="addExpandClass(sidebarnavItem.title)"
                    [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'">
                    <i [ngClass]="[sidebarnavItem.icon]"></i>
                    <span class="hide-menu">{{sidebarnavItem.title}}</span>
                </a>
                <!-- Second level menu -->
                <ul aria-expanded="false" class="collapse first-level"
                    *ngIf="sidebarnavItem.submenu.length > 0"
                    [ngClass]="{'in' : showMenu === sidebarnavItem.title }">
                    <li class="sidebar-item"
                        *ngFor="let sidebarnavSubItem of sidebarnavItem.submenu | filterParentMenuId:pMenuId | filterLimitLevel:userGroupId"
                        [class.active]="showSubMenu === sidebarnavSubItem.title"
                        [routerLinkActive]="sidebarnavSubItem.submenu.length > 0 ? '' : 'active'">
                        <a class="sidebar-link" [routerLink]="sidebarnavSubItem.submenu.length > 0 ? null : [sidebarnavSubItem.path]" [routerLinkActive]="sidebarnavSubItem.submenu.length > 0 ? '' : 'router-link-active'"
                            [ngClass]="[sidebarnavSubItem.class]" *ngIf="!sidebarnavSubItem.extralink;" (click)="addActiveClass(sidebarnavSubItem.title)">
                            <i [ngClass]="[sidebarnavSubItem.icon]"></i>
                            <span class="hide-menu">{{sidebarnavSubItem.title}}</span>
                        </a>
                        <!-- Third level menu -->
                        <ul aria-expanded="false" class="collapse Second-level"
                            *ngIf="sidebarnavSubItem.submenu.length > 0"
                            [ngClass]="{'in' : showSubMenu === sidebarnavSubItem.title }">
                            <li class="sidebar-item"
                                *ngFor="let sidebarnavSubsubItem of sidebarnavSubItem.submenu"
                                routerLinkActive="active"
                                [ngClass]="[sidebarnavSubsubItem.class]">
                                <a class="sidebar-link" [routerLink]="[sidebarnavSubsubItem.path]" *ngIf="!sidebarnavSubsubItem.extralink;" [routerLinkActive]="sidebarnavSubsubItem.submenu.length > 0 ? '' : 'router-link-active'">
                                    <i [ngClass]="[sidebarnavSubsubItem.icon]"></i>
                                    <span class="hide-menu">{{sidebarnavSubsubItem.title}}</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ng-container>
    </ul>
    <!-- <ul>
        <li></li>
    </ul> -->
</nav>